export enum TicketGenerationType
{
    Print = 1,
    Sms = 2,
    PrintOrSms = 3
}